// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_o8-0";
export var buttonContainer = "_o8-3";
export var cancelButton = "_o8-4";
export var headerSection = "_o8-6";
export var headerTitle = "_o8-9";
export var messageSideLeft = "_o8-1";
export var messageSideRight = "_o8-2";
export var orderNumberContainer = "_o8-7";
export var orderNumberLabel = "_o8-8";
export var submitButton = "_o8-5";